module.exports = __webpack_public_path__ + "static/media/vessel.7eef8b7c.png";